import { Chip } from "@mui/material";
import genericStyles from "../../Styles/genericStyles.module.css";
import Config from "../../Utils/Config";
import { EComponentTypes, ETableEditAction } from "../../Utils/Enums";
import { endpoints } from "../../Utils/UrlEnum";
import { Vocabulary } from "../../Utils/Vocabulary";
import MUIDataTableCustomStyle from "../MUIDataTableCustomStyle";
import Filters from "../Widgets/Filters";
import { formatDate } from "../../Utils/Utils";
import { ExpirationStatusBadge } from "../ExpirationStatusBadge";

export default function UserDocumentsExpiration() {
  const columns = [
    {
      name: "isExpired",
      label: Vocabulary.isExpired,
      options: {
        display: false,
      },
    },
    {
      name: "username",
      label: Vocabulary.username,
    },
    {
      name: "roleIds",
      label: Vocabulary.role,
      options: {
        customBodyRender: (roleIds: any) => {
          return roleIds?.map((role: any) => {
            return (
              <Chip
                sx={{ backgroundColor: "white !important", fontWeight: "500" }}
                key={role._id}
                label={role.name}
                style={{
                  padding: 5,
                  marginRight: 5,
                }}
              />
            );
          });
        },
      },
      exportValue: (roleIds: any) => {
        return roleIds?.map((role: any) => role.name).join(", ") || "";
      },
    },
    {
      name: "fullName",
      label: Vocabulary.name,
    },
    {
      name: "document",
      label: Vocabulary.documentType,
      options: {
        sortField: "documentName",
        customBodyRender: (document: any) => {
          return document?.name;
        },
        exportValue: (document: any) => {
          return document?.name || "";
        },
      },
    },
    {
      name: "document",
      label: Vocabulary.expirationDocumentDate,
      options: {
        sortField: "document.expirationDate",
        customBodyRender: (document: any) => {
          return formatDate(document?.expirationDate);
        },
        exportValue: (document: any) => {
          return formatDate(document?.expirationDate) || "";
        },
      },
    },
    {
      name: "monthsTillExpiration",
      label: Vocabulary.nrOfRemainingMonths,
      options: {
        customBodyRender: (value: number, tableMeta: any) => {
          const isExpired = tableMeta?.rowData?.[0];
          return <ExpirationStatusBadge value={value} isExpired={isExpired} />;
        },
        exportValue: (value: number, tableMeta: any) => {
          const isExpired = tableMeta?.isExpired;
          return isExpired
            ? `Expirat de  ${value} luni`
            : `${Vocabulary.expireIn} ${value} luni`;
        },
      },
    },
  ];

  const filters = [
    {
      property: "documentName",
      autocompleteFilterProperty: "type",
      label: Vocabulary.documentType,
      type: EComponentTypes.AUTOCOMPLETE,
      validation: null,
      defaultValue: null,
      options: Config.userDocuments || [],
    },
  ];
  return (
    <div className={genericStyles.mainContainer}>
      <Filters filters={filters} defaultOpen />
      <MUIDataTableCustomStyle
        buttons={[]}
        onEditAction={ETableEditAction.NONE}
        title={""}
        hideAddButton={true}
        columns={columns}
        CRUDEndPoint={endpoints.user.expiredDocuments}
        hideEditButton={true}
        hideDeleteButton={true}
        showDownloadButton
        showPrintButton
        exportWithTimestamp
      />
    </div>
  );
}
